import React, {useState, useEffect, useRef} from 'react';
import Line from './Line';
import VLine from './VLine';
import {Group} from '@vx/group';
import Boxy from './Boxy'
import styled from 'styled-components';
import phaseIcon from './../../../Assets/Icons/phase_sm.svg';
import Label from './Label';
import {ReactComponent as LeftIcon} from './../../../Assets/Icons/arrow_left.svg';
import {ReactComponent as RightIcon} from './../../../Assets/Icons/arrow_right.svg';
import {Row, Col, Container, Icon} from "atomize";
import theme from "../../../Theme/Theme";
import ExperienceModal from "../../Molecules/ExperienceModal";
import ScheduleModal from "../../Molecules/ScheduleModal";
import BundlesModal from "../../Molecules/BundlesModal";
import {PrimaryButton} from "../../Atoms/Button";

const MainContainer = styled(Container)`
    margin-top: 1rem;
`;

const XLabel = styled.div`
  display: flex;
  justify-content: center;
  p {
    font-weight: 700;
    font-family: Inter;
    font-size: 16px;
    color: #0A1F44;
    letter-spacing: 0;
    line-height: 30px;
    
    :before {
      border-radius: 12px;
      content: " ";
      display: inline-block;
      margin-right: 8px;
      margin-bottom: -1px;
      height: 12px;
      width: 12px;
      background-image: url(${phaseIcon});
    }
  }
`;

const Key = styled.div`
  margin-top: 2rem;
  border: 1px solid #C9CED6;
  padding: 1rem;
  @media (min-width: 767px) {
    //max-width: 250px;
    //width: 100%;
  }
  border-radius: 2px;
  display: flex;
  justify-content: center;
  
  h4 {
  font-family: Inter;
  font-weight: 700;
  font-size: 16px;
  color: #0A1F44;
  letter-spacing: 0;
  line-height: 30px;
  margin-bottom: 1rem;
  }
  ul {
    margin: 0;
    padding-left: 1.5rem;
    list-style: none;
  }
  li {
    margin: 0.5rem 0px;
    color: rgb(10, 31, 68);
    font-family: Inter;
    font-size: 14px;
    line-height: 24px;
    :first-of-type:before {
        content: "";
        background-color: rgb(246, 118, 0);
        position: absolute;
        width: 1rem;
        height: 1rem;
        margin-left: -1.5rem;
        margin-top: 0.25rem;
        border-radius: 100%;
    }
    :nth-of-type(2):before {
        content: "";
        background-color: rgb(6, 117, 67);
        position: absolute;
        width: 1rem;
        height: 1rem;
        margin-left: -1.5rem;
        margin-top: 0.25rem;
        border-radius: 100%;
    }
    :nth-of-type(3):before {
        content: "";
        background-color: rgb(17, 106, 217);
        position: absolute;
        width: 1rem;
        height: 1rem;
        margin-left: -1.5rem;
        margin-top: 0.25rem;
        border-radius: 100%;
    }
  }
`;

const Schedule = styled.div`
  margin-top: 2rem;
  border: 1px solid #C9CED6;
  padding: 1rem;
  @media (min-width: 767px) {
    //max-width: 300px;
    //width: 100%;
  }
  border-radius: 2px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  h4 {
    font-family: Inter;
    font-weight: 700;
    font-size: 16px;
    color: #0A1F44;
    letter-spacing: 0;
    line-height: 30px;
    margin-bottom: .5rem;
  }
`

const Wrapper = styled.div`
  overflow-x: scroll;
  width: 100%;
  background: rgba(0,69,140,0.075);
  border-radius: 9px;
  display: flex;
  margin-top: 2rem;
  padding-top: 2rem;
`;

const OuterWrapper = styled.div`
  display: flex;
  .button-wrapper {
    position: relative;
    button {
      position: absolute;
      top: calc(50% - 1rem);
      left: -1rem;
      background-color: white;
      cursor: pointer;
      box-shadow: rgba(8,11,14,0.06) 0px 0px 1px 0px, rgba(8,11,14,0.1) 0px 32px 40px -1px;
      padding: .5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      
      svg {
        height: 1rem;
        width: 1rem;
      }
    }
  }
`;

const Yaxis = styled.div`
  display: flex;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding-top: 2.25rem;
  p {
    font-family: Inter;
    font-size: 12px;
    color: #444444;
    max-width: 95px;
    line-height: 16px;
  }
`;

const LoadingWrapper = styled.div`
  height: 300px;
  width: 100%;;
  display: flex;
  justify-content: center;
  align-items: center;
`

function TimeLineGraph(props) {
  const [activitiesPhase1, setActivitiesPhase1] = useState([]);
  const [phase1Max, setPhase1Max] = useState(null);
  const [activitiesPhase2, setActivitiesPhase2] = useState([]);
  const [phase2Max, setPhase2Max] = useState(null);
  const [activitiesPhase3, setActivitiesPhase3] = useState([]);
  const [phase3Max, setPhase3Max] = useState(null);
  const refContainer = useRef(null);
  const [experienceModalOpen, setExperienceModalOpen] = useState(false);
  const [scheduleModalOpen,setScheduleModalOpen] = useState(false);
  const [bundleModalOpen,setBundleModalOpen] = useState(false);

  useEffect(() => {

    const arrange = (activities) => {
      let a = [];
      let wl = 0;
      let sd = 0;
      let ia = 0;
      let ga = 0;

      let totalD = 0;

      let lastType = [null,null];
      let sdType = 'Stimulus / Discussion';
      let wlType = 'Workshop / Lab';
      let iaType = 'Individual Assignment';
      let gaType = 'Group Assignment';

      activities.forEach(activity => {

        if (activity.field_activity_type.name === sdType) {
          activity.y = 25;
          activity.x = lastType[1] === sdType ? sd + 175 : lastType[0] === sdType ? sd + 175 : totalD + 35;
          totalD = activity.x;
          sd = totalD;
          lastType.shift();
          lastType.push(sdType);
        } else if (activity.field_activity_type.name === wlType) {
          activity.y = 100;
          activity.x = lastType[1] === wlType ? wl + 175 : lastType[0] === wlType ? wl + 175 : totalD + 35;
          totalD = activity.x;
          wl = totalD;
          lastType.shift();
          lastType.push(wlType);
        } else if (activity.field_activity_type.name === iaType) {
          activity.y = 175;
          activity.x = lastType[1] === iaType ? ia + 175 : lastType[0] === iaType ? ia + 175 : totalD + 35;
          totalD = activity.x;
          ia = totalD;
          lastType.shift();
          lastType.push(iaType);
        } else if (activity.field_activity_type.name === gaType) {
          activity.y = 250;
          activity.x = lastType[1] === gaType ? ga + 175 : lastType[0] === gaType ? ga + 175 : totalD + 35;
          totalD = activity.x;
          ga = totalD;
          lastType.shift();
          lastType.push(gaType);
        }
        a.push(activity);
      });
      return {activities: a, max: Math.max(totalD,wl,sd,ia,ga) + 175};
    };

    if (props.activitiesPhase1) {
      const a1 = arrange(props.activitiesPhase1);
      setActivitiesPhase1(a1.activities);
      setPhase1Max(a1.max);
    }
    if (props.activitiesPhase2) {
      const a2 = arrange(props.activitiesPhase2);
      setActivitiesPhase2(a2.activities);
      setPhase2Max(a2.max);
    }
    if (props.activitiesPhase3) {
      const a3 = arrange(props.activitiesPhase3);
      setActivitiesPhase3(a3.activities);
      setPhase3Max(a3.max);
    }

  }, [props.activitiesPhase1, props.activitiesPhase2, props.activitiesPhase3]);

  const onRightClick = () => {
    let pos = refContainer.current.scrollLeft;
    refContainer.current.scrollTo({left: pos + 600, behavior: 'smooth'});
  };


  const onLeftClick = () => {
    let pos = refContainer.current.scrollLeft;
    refContainer.current.scrollTo({left: pos - 600, behavior: 'smooth'});
  };

  return (
    <MainContainer>
      <OuterWrapper>
        <Yaxis>
          <p>Stimulus / Discussion</p>
          <p>Workshop / Lab</p>
          <p>Individual Assignment</p>
          <p>Group Assignment</p>
        </Yaxis>
        <div className={'button-wrapper'}>
          <button
            className={'scroll-left'}
            aria-label={'Scroll left'}
            onClick={() => onLeftClick()}
          >
            <LeftIcon/>
          </button>
        </div>
        <Wrapper ref={refContainer}>

          {
            phase1Max && phase2Max && phase3Max?
            <>
              <div>
                <svg width={phase1Max} height={'325px'}>
                  <Line
                    y={25 + 17}
                    x={0}
                    width={phase1Max}
                  />
                  <Line
                    y={100 + 17}
                    x={0}
                    width={phase1Max}
                  />
                  <Line
                    y={175 + 17}
                    x={0}
                    width={phase1Max}
                  />
                  <Line
                    y={250 + 17}
                    x={0}
                    width={phase1Max}
                  />
                  {activitiesPhase1.length > 0 &&
                  <Label
                    y={305}
                    x={5}
                    title={"Who’s our partner?"}
                  />
                  }
                  <Group>
                    {activitiesPhase1.map((point, i) => {
                      return (
                        <Boxy
                          key={point.title}
                          x={point.x}
                          y={point.y}
                          fill={point.field_experience_layer.field_color ? point.field_experience_layer.field_color.color : '#333'}
                          title={point.title}
                          activity={point}
                        />
                      );
                    })}
                  </Group>
                </svg>
              </div>
              <div>
                <svg width={phase2Max} height={'325px'}>
                  {activitiesPhase2.length > 0 &&
                  <>
                    <VLine
                      height={'325px'}
                      h={'325'}
                    />
                    <Label
                      y={305}
                      x={5}
                      title={"What's our project?"}
                    />
                  </>
                  }
                  <Line
                    y={25 + 17}
                    x={0}
                    width={phase2Max}
                  />
                  <Line
                    y={100 + 17}
                    x={0}
                    width={phase2Max}
                  />
                  <Line
                    y={175 + 17}
                    x={0}
                    width={phase2Max}
                  />
                  <Line
                    y={250 + 17}
                    x={0}
                    width={phase2Max}
                  />
                  <Group>
                    {activitiesPhase2.map((point, i) => {
                      return (
                        <Boxy
                          key={point.title}
                          x={point.x}
                          y={point.y}
                          fill={point.field_experience_layer.field_color ? point.field_experience_layer.field_color.color : '#333'}
                          title={point.title}
                          activity={point}
                        />
                      );
                    })}
                  </Group>
                </svg>
              </div>
              <div>
                <svg width={phase3Max} height={'325px'}>
                  {activitiesPhase3.length > 0 &&
                  <>
                    <VLine
                      height={'325px'}
                      h={'325'}
                    />
                    <Label
                      y={305}
                      x={5}
                      title={"What's our product?"}
                    />
                  </>
                  }
                  <Line
                    y={25 + 17}
                    x={0}
                    width={phase3Max}
                  />
                  <Line
                    y={100 + 17}
                    x={0}
                    width={phase3Max}
                  />
                  <Line
                    y={175 + 17}
                    x={0}
                    width={phase3Max}
                  />
                  <Line
                    y={250 + 17}
                    x={0}
                    width={phase3Max}
                  />
                  <Group>
                    {activitiesPhase3.map((point, i) => {
                      return (
                        <Boxy
                          key={point.title}
                          x={point.x}
                          y={point.y}
                          fill={point.field_experience_layer.field_color ? point.field_experience_layer.field_color.color : '#333'}
                          title={point.title}
                          activity={point}
                        />
                      );
                    })}
                  </Group>
                </svg>
              </div>
            </>
            :
            <LoadingWrapper>
              <Icon name="Loading" size="40px" color={theme.colors.primary} />
            </LoadingWrapper>
          }
        </Wrapper>
        <div className={'button-wrapper'}>
          <button className={'scroll-right'}>
            <RightIcon
              onClick={() => onRightClick()}
            />
          </button>
        </div>
      </OuterWrapper>
      <XLabel>
        <p>
          Course phases
        </p>
      </XLabel>
      <Row
        style={{marginTop: '2rem'}}
      >
        <Col
          size={{ xs: '12', sm: '12', md: '6', lg: '4' }}
        >
          <Key>
            <div>
              <h4>Experience layers <a
                href={"#"}
                className={'info-btn'}
                aria-label={'more information about experience options'}
                onClick={e => {
                  e.preventDefault();
                  setExperienceModalOpen(true);
                }}
              >
                <Icon
                  name="Info"
                  size="20px"
                  color={theme.colors.gray}
                />
              </a>
              </h4>
              <ExperienceModal
                open={experienceModalOpen}
                close={() => setExperienceModalOpen(false)}
              />
              <ul>
                <li>Student, Team, Class</li>
                <li>Community partner</li>
                <li>Society</li>
              </ul>
            </div>
          </Key>
        </Col>
        <Col
          size={{ xs: '12', sm: '12', md: '6', lg: '4' }}
        >
          <Schedule>
            <h4>Daily schedule of activities</h4>
            <p>Interested in using the full Engineering For Humanity daily schedule of activities?</p>
            <PrimaryButton
              text={"View the schedule"}
              action={() => setScheduleModalOpen(true)}
              type={'button'}
              icon={"Eye"}
            />
            <ScheduleModal
              open={scheduleModalOpen}
              close={() => setScheduleModalOpen(false)}
            />
          </Schedule>
        </Col>
        <Col
          size={{ xs: '12', sm: '12', md: '6', lg: '4' }}
        >
          <Schedule>
            <h4>Activity bundles</h4>
            <p>Interested in using curated mixes for different uses?</p>
            <PrimaryButton
              text={"View activity bundles"}
              action={() => setBundleModalOpen(true)}
              type={'button'}
              icon={"Eye"}
            />
            <BundlesModal
              open={bundleModalOpen}
              close={() => setBundleModalOpen(false)}
            />
          </Schedule>
        </Col>
      </Row>
    </MainContainer>
  )
}

export default TimeLineGraph;
